import React from 'react';
import { connect } from "react-redux";
import CustomPaper from '../../../shared/utils/CustomPaper';
import conf from './../../../../config';
import ExcelUploadBtn from './ExcelUploadBtn';
import ListDesSalaries from './ListeDesSalaries';
import OneSalarieForm from './OneSalarieForm';

class AjouterDesSalaries extends React.Component {



    render() {
        return (
            <div>
                <CustomPaper title='Ajouter des salariés'>
                    <div>
                        <p style={{ paddingTop: 5 }}>Pour ajouter plusieurs salariés à la fois vous pouvez importer un fichier Excel de vos salarié, Veuillez pour cela télécharger le modèle en <a download href={conf.upload_path + '/excel/MODELE_SALARIES.xls'}>cliquant ici</a> et le remplir avec les informations demandées.</p>
                        <ExcelUploadBtn />
                    </div>
                </CustomPaper>
                <div className={'row'}>
                    <div className={'col-md-6'}>
                        <CustomPaper title='Ajouter un salarié'>
                            <OneSalarieForm
                                submitSuccessMsg="Ajout effectué avec succès."
                                submitBtnTxt='Ajouter'
                                initialState={null}
                                submitMethod='POST'
                            />
                        </CustomPaper>
                    </div>
                    <div className={'col-md-6'}>
                        <CustomPaper title='Liste des salariés enregistrés'>
                            <ListDesSalaries />
                        </CustomPaper>
                    </div>


                </div>

            </div>
        );
    }
}

function mapStateToProps(store) {
    return { open: store.shared.drawer.open }
}

export default connect(mapStateToProps)(AjouterDesSalaries);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/salaries/AjouterDesSalaries.js